import React from 'react';
import { useLocation } from 'react-router-dom';
import { Logo } from './Logo';

// En /mcp, la página de Clerk, se carga con el logo de Clerk y no con el de JBM
// (Joan, 2026-10-27). El mismo lockup sin placa que abre esa página.
export const LoadingScreen: React.FC = () => {
  const enClerk = useLocation().pathname === '/mcp';
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-charcoal-50 to-steel-blue-50 dark:from-charcoal-900 dark:to-charcoal-800">
      {enClerk ? (
        <img src="/images/clerk-lockup.png" alt="Clerk" className="h-16 w-auto sm:h-20 md:h-24" width={1062} height={407} />
      ) : (
        <>
          <Logo className="h-16 w-auto sm:h-20 md:h-24 opacity-90 dark:hidden" inverted={false} />
          <Logo className="h-16 w-auto sm:h-20 md:h-24 opacity-90 hidden dark:block" inverted />
        </>
      )}
      <div className="mt-6 h-8 w-8 animate-spin rounded-full border-2 border-steel-blue border-t-transparent" />
    </div>
  );
};
